export const courseDeta = [
    {
        "name": "Main Content: ",
        "content": "Online Chinese Lesson content includes pinyin and literacy. Help children Learn Chinese Characters and phonics in preschool. And the basic cognition of Chinese characters.",
    },
    {
        "name": "Details:",
        "content": "The content of the Pinyin course: natural spelling, master the pronunciation and spelling of Pinyin;\nChinese character course content: Enlightenment of Chinese characters, understand the basic knowledge of Chinese characters, master commonly used Chinese characters, establish the concept of Chinese characters, and improve the ability to perceive Chinese characters.",
    }
]
export const courseDeta2 = [
    {
        number: "01",
        color: "#4C9EE1",
        bagColor: "#E9F8FF",
        "content": "Phonics of pinyin; Chinese character reading and writing, strokes, radicals; Description of daily communication, simple life scenes.",
    },
    {
        number: "02",
        color: "#4540E1",
        bagColor: "#EFEFFF",
        "content": "Improve oral skills, develop vocabulary, phrases, short sentences written and expressed. Complete a short conversation. Complete a short essay of 200 words.",
    },
    {
        number: "03",
        color: "#FC9E5C",
        bagColor: "#FFF4EF",
        "content": "Practice dialogue reading, cultivate picture analysis skills, and practice reading pictures and speaking; Cultivate the habit of using high-frequency vocabulary in daily communication and improve reading skills.",
    },
    {
        number: "04",
        color: "#FA8F80",
        bagColor: "#FDF0ED",
        "content": "Improve reading skills, be able to use everyday vocabulary and sentences to construct mental logic and discuss a variety of topics. Initially establish a complete article writing system.",
    },
    {
        number: "05",
        color: "#C557CF",
        bagColor: "#FBF0FD",
        "content": "Improve paragraph writing skills, be able to complete 400–word essays. Be able to establish logical thinking in Chinese, complete the statement of topics, and choose different styles suitable for writing and speaking.",
    },
    {
        number: "06",
        color: "#71E2A6",
        bagColor: "#F0FCF6 ",
        "content": "Expand rich vocabulary, improve language organization skills, and complete 500-word essays. Develop confidence and skills in oral expression through reading discussions, audiovisual material analysis, and in-class interactions to prepare for the PSLE exam.",
    }
]
export const courseDeta3 = [
    {
        "title": "1-on-1 Private Lessons",
        "picture": "../assets/singapore/why1.jpg"
    },
    {
        "title": "Experienced Singapore MOE Syllabus Teachers",
        "picture": "../assets/singapore/why2.png"
    },
    {
        "title": "Interesting Class Content",
        "picture": "../assets/singapore/why3.jpg"
    },
    {
        "title": "All age covered courses",
        "picture": "../assets/singapore/why4.jpg"
    },
    {
        "title": "Flexible Class Time",
        "picture": "../assets/singapore/why5.jpg"
    },
    {
        "title": "Kindly Personalized Helping Teacher",
        "picture": "../assets/singapore/why6.jpg"
    }
]
export const parentsList = [
    {
        "name": "Jenny Wilson",
        "age": " Learning Chinese since 2021 ",
        "introduce": "Words from Sino-bus Students & Parents",
        "message": "My son has learned Chinese with sino-bus since last summer. He has two classes every week. Although he has to finish some homework twice a week, he doesn't complain anything about these classes. His teacher is very patient and knowledgeable, so he likes to communicate with her. I feel he has improved a lot. We both recommend sino-bus online Chinese class.",
        'picture': "../assets/singapore/banner6-1.png"
    },
    {
        "name": "freda",
        "age": "Learning Chinese since 2020",
        "introduce": "Words from Sino-bus Students & Parents",
        "message": "My daughter likes to attend the classes and finds the teacher very kind. I am very happy that she likes to attend the classes. The teacher and the team are very responsive whenever I have queries. Will not hesitate to recommend Sino-bus.The courses they run in Singapore are really good!",
        'picture': "../assets/singapore/banner6-2.png"
    },
    {
        "name": "elsa",
        "age": "Learning Chinese since 2022",
        "introduce": "Words from Sino-bus Students & Parents",
        "message": "For me and my kids. the teacher has had a huge impact on why I stay at Sinobus. As I already mentioned to her, she is very efficient, very patient and excellent at customer service. Sinobus should be proud to have employees like her. Without her support, I would have stopped enrolling as the application and course process is very confusing. There needs to be a clearer process about what happens after the trial session.",
        'picture': "../assets/singapore/banner6-3.png"
    },
    {
        "name": "sylvia",
        "age": "Learning Chinese since 2021 ",
        "introduce": "Words from Sino-bus Students & Parents",
        "message": "We had a great experience from beginning to now with our coordinator Zoe and our teacher Zhou Laoshi! They make it pleasant and are very welcoming and helpful team! My son has so much fun in the Chinese class in Singapore, he tells me how great it is afterwards! The teacher really has a talent for teaching and enjoys what she does. My child’s Chinese has dramatically improved since starting these classes 2x per week.",
        'picture': "../assets/singapore/banner6-4.png"
    },
    {
        "name": "purplegrape",
        "age": "Learning Chinese since 2023",
        "introduce": "Words from Sino-bus Students & Parents",
        "message": "My girl has been learning Chinese lesson with Sinobus about half year, the teachers are truly invested in my children’s education and her growth as learners. Adjustments are made as needed to meet the needs of the student. One to one learning program and leveled learning have enabled my children to gain confidence in their learning abilities. Love Ms. Zhou. She is always here when I need help. Thanks for all.",
        'picture': "../assets/singapore/banner6-5.png"
    },
    {
        "name": "frederica",
        "age": "Learning Chinese since 2021 ",
        "introduce": "Words from Sino-bus Students & Parents",
        "message": "Sino-bus is an amazing program that efficiently helps my children learn! Not only is the content engaging, the teachers are supportive, kind, and hard working. This is the best environment for my children to learn in, I have already seen incredible progress. Sino-bus has numerous resources to help strengthen reading, writing, and speaking skills. I am truly satisfied and would recommend Sino-bus! Children who need to learn Chinese in Singapore can really try.",
        'picture': "../assets/singapore/banner6-6.png"
    }
]
export const teacherDataList = [
    {
        "name": "Teacher Weiwei",
        "quality": "43 active students",
        "introduce": "Graduated from Hebei Science and Technology Normal University with a bachelor's degree. The existing relevant certificates include: Putonghua 2A, teacher qualification certificate, international Chinese teacher certificate, etc.; 5 years of teaching experience, good at children's Chinese enlightenment, children's reading companionship, primary school reading and writing;Teching characteristics: patience Meticulous, teach students in accordance with their aptitude, entertaining and entertaining.\n",
        "pictureMob": "http://sino-java.oss-cn-shenzhen.aliyuncs.com/2024-04-08/t11712560362539.jpg?Expires=4866160362&OSSAccessKeyId=LTAI5t7JyJTMUGbf7rtfejnV&Signature=RSn5fhkG0xivRFZjqk8gt99sDVU%3D",
        "remark": "5,400+ classes",
        'picture': "../assets/singapore/teacher1.jpg"
    },
    {
        "name": "Teacher Zhu",
        "quality": "52 active students",
        "introduce": " Postgraduate of China University of Petroleum, Putonghua 2A, English level 4, Korean level 6, good at primary school Chinese, pinyin, Chinese teaching, HSK, YCT, happy partner, reading and writing, etc.;  Teaching characteristics: patience, cheerful and lively personality, teaching students according to their aptitude, good at guiding;\n              ",
        "pictureMob": "http://sino-java.oss-cn-shenzhen.aliyuncs.com/2024-04-08/t21712560253307.jpg?Expires=4866160253&OSSAccessKeyId=LTAI5t7JyJTMUGbf7rtfejnV&Signature=kspObTHSMHsHWtR%2FosZ5rLT8Fm4%3D",
        "remark": "4,990+ classes",
        'picture': "../assets/singapore/teacher2.jpg"
    },
    {
        "name": "Teacher Wu",
        "quality": "46 active students",
        "introduce": " Graduated from Hebei University of Science and Technology with a bachelor's degree in English, primary school English teacher qualification certificate, English major certificate four; good at HSK, primary school Chinese, easy-to-learn Chinese, four-five fast reading, JIda university Chinese, 2 years of teaching experience in reading and writing;Teaching characteristics: lively and humorous , teach students in accordance with their aptitude, and be patient.\n              ",
        "pictureMob": "http://sino-java.oss-cn-shenzhen.aliyuncs.com/2024-04-08/t31712560266656.jpg?Expires=4866160266&OSSAccessKeyId=LTAI5t7JyJTMUGbf7rtfejnV&Signature=SNetUuCbkcLEGzppFpJnQhcGsMA%3D",
        "remark": "5,140+ classes",
        'picture': "../assets/singapore/teacher3.jpg"
    }
]